export const handleRedirect = (redirect, context) => {
  let url = '';
  if (redirect) {
    if (redirect === '/awto' || redirect === '/awto/') {
      if (context === 'admin') {
        url = '/admin/home';
      } else {
        url = '/awto/account';
      }
    } else if (redirect === '/admin' || redirect === '/admin/') {
      url = '/admin/home';
    } else {
      if (context === 'admin') {
        if (redirect.search('/awto') === -1) {
          url = redirect;
        } else {
          url = '/admin/home';
        }
      }
    }
  } else {
    if (context === 'admin') {
      url = '/admin/home';
    } else {
      url = '/awto/account';
    }
  }
  return url;
};
